import { Helmet } from 'react-helmet-async';
import { forwardRef, ReactNode } from 'react';
// material
import { Box, BoxProps } from '@mui/material';
import useBackendSetting from '../hooks/useBackendSetting';
// ----------------------------------------------------------------------

interface PageProps extends BoxProps {
  children: ReactNode;
  title?: string;
}

const Page = forwardRef<HTMLDivElement, PageProps>(({ children, title = '', ...other }, ref) => {
  const setting = useBackendSetting('Firma');

  return (
    <Box ref={ref} {...other}>
      <Helmet>
        <title>{`${title} | ${setting ? setting['Firma'] : ''}`}</title>
      </Helmet>
      {children}
    </Box>
  );
});

export default Page;
